<div class="Dialog Help w-[350px]">
  <mat-toolbar class="Dialog__header">
    <mat-toolbar-row class="Dialog__toolbar">
      <h2>{{ data?.title || 'Vad behöver du hjälp med?' }}</h2>
    </mat-toolbar-row>
    <mat-toolbar-row class="Dialog__toolbar Help__searchrow" *ngIf="!data?.hideSearch">
      <mat-form-field class="w-full">
        <mat-label>Sök</mat-label>
        <input matInput type="search" [formControl]="searchControl" autocomplete="off" />
      </mat-form-field>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-progress-bar mode="indeterminate" [hidden]="!IS_LOADING"></mat-progress-bar>
  <div mat-dialog-content class="Dialog__content" [class.Dialog__content--nosearch]="data?.hideSearch">
    <mat-nav-list *ngIf="posts$ | async as posts" class="pt-0">
      <a mat-list-item *ngFor="let post of posts.data" (click)="viewPost($event, post)" href="#" class="Help-item py-2">
        <div matListItemTitle>
          <div class="flex flex-col">
            <div class="flex" *ngIf="post.categories?.length">
              <span
                class="Help-item__category"
                *ngFor="let category of post.categories"
                [style.--category-background]="category.getMeta('color')"
                >{{ category.title }}</span
              >
            </div>

            <h3 class="Help-item__title mb-3">
              <span
                class="Help-item__title__unread-notification"
                *ngIf="data?.showNotificationBadge"
                [hidden]="!(postHasNotification(post) | async)"
              ></span
              >{{ post.title }}
            </h3>
          </div>
        </div>
        <p matListItemLine class="Help-item__excerpt" *ngIf="post.excerpt">
          <span [innerHtml]="post.excerpt || (post.content | striphtml)"></span>
        </p>
        <div matListItemLine *ngIf="data?.showDate">
          <span class="text-gray text-small">{{ post.publish_at | amDateFormat: 'YYYY-MM-DD HH:mm' }}</span>
        </div>
        <div class="flex pb-1" matListItemLine *ngIf="post.attr('keyword')">
          <span class="Help-item__category Help-item__category--tag" *ngFor="let tag of post.attrs('keyword')">{{ tag }}</span>
        </div>
      </a>
    </mat-nav-list>
  </div>
</div>
